import { MatDialogRef } from '@angular/material/dialog';
import { DebugLogger } from '@orderna/admin-panel/src/app/shared/components/debug-logger/debug-logger.service';
import { blurActiveElement } from '@orderna/admin-panel/src/utils/blur-active-element';

const VIEWPORT_STABLE_DURATION = 150;
const MAX_WAIT_DURATION = 1_000;

const waitUntilViewportStable = (debugLogger?: DebugLogger): Promise<void> => {
  return new Promise((resolve) => {
    const viewport = window.visualViewport;

    if (!viewport) {
      resolve();
      return;
    }

    let stableTimer: ReturnType<typeof setTimeout>;
    let maxWaitTimer: ReturnType<typeof setTimeout>;

    const cleanup = () => {
      viewport.removeEventListener('resize', onResize);
      clearTimeout(stableTimer);
      clearTimeout(maxWaitTimer);
    };

    const finish = () => {
      debugLogger?.log('viewport.stable');
      cleanup();
      resolve();
    };

    const onResize = () => {
      debugLogger?.log('viewport.resize (waiting for stable)');
      clearTimeout(stableTimer);
      stableTimer = setTimeout(finish, VIEWPORT_STABLE_DURATION);
    };

    viewport.addEventListener('resize', onResize);

    // If the keyboard is already closed and no resize occurs,
    // don't wait forever.
    stableTimer = setTimeout(finish, VIEWPORT_STABLE_DURATION);

    maxWaitTimer = setTimeout(finish, MAX_WAIT_DURATION);
  });
};

export const closePointOfSalesModal = async <T, R = any>(
  dialogRef: MatDialogRef<T, R>,
  result?: R,
  debugLogger?: DebugLogger,
): Promise<void> => {
  const isAndroid = /android/i.test(navigator.userAgent);

  if (!isAndroid) {
    dialogRef.close(result);
    return;
  }

  blurActiveElement();

  await waitUntilViewportStable(debugLogger);

  await new Promise(requestAnimationFrame);
  debugLogger?.log('dialog.raf1');

  await new Promise(requestAnimationFrame);
  debugLogger?.log('dialog.raf2');

  dialogRef.beforeClosed().subscribe(() => {
    debugLogger?.log('dialog.beforeClosed');
  });

  dialogRef.afterClosed().subscribe(() => {
    debugLogger?.log('dialog.afterClosed');
  });

  dialogRef.close(result);
};
